


































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import DataRujukan from "@/services/DataRujukan";
import DataUtility from "@/services/DataUtility";
// import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import SuratRujukanRanap from "@/services/SuratRujukanRanap";
import { storeSuratRujukanRanap } from "@/store/modules/SuratRujukanRanap";
import { storeDokter } from "@/store/modules/dokter";

@Component({
  components: {
    CardModalTtd
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class RujukanRanapInputModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() err!: object;
  @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() rm: string;
  // @Prop() tujuan: { id: number; nama: string };
  @Prop() dataRujukan: object;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  tujuan: { id: number; nama: string } = null;

  searchStringFaskes = "";
  listFaskes = [];
  validasi = [v => !!v || "*Kolom ini harus diisi"];
  unit_tujuan_text = "";
  diagnosis = "";
  alasan = "";
  kondisi = "";
  terapi_diberikan = "";
  penunjang = "";
  terapi_diharapkan = "";
  modalTtd = false;
  alert = "";
  dokter_id = null;
  saving = false;

  listFaskesLainnya = [];

  mounted() {
    this.getFaskesList();
  }

  get storeUser() {
    return userModule.user;
  }

  get storeRujukan() {
    return storeSuratRujukanRanap.rujukan;
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  get listDokter() {
    return storeDokter.list;
  }

  get isUserSignee() {
    return this.storeRujukan.dokter?.id == this.storeUser.id;
  }

  getFaskesList() {
    const faskes = DataUtility.getListFaskes();
    faskes.then(faskes => {
      this.listFaskes = faskes;
    });
  }

  // @Watch("value")
  // changeValue(val) {
  //   //
  // }

  @Watch("dataRujukan", { deep: true })
  changeRujukan(value) {
    console.log("change data rujukan", value);
    const isAllNull = Object.values(value).every(val => !val);

    if (!isAllNull) {
      const isTujuanLain = value.tujuan && value.tujuan.id.includes("#");

      if (isTujuanLain) {
        this.tujuanLainnya = value.tujuan;
        this.showInputFaskesLainnya = true;
      } else {
        this.tujuan = value.tujuan;
        this.showInputFaskesLainnya = false;
      }

      this.unit_tujuan_text = value.unit_tujuan_text;
      this.diagnosis = value.a;
      this.alasan = value.alasan;
      this.kondisi = value.kondisi;
      this.terapi_diberikan = value.terapi_diberikan;
      this.penunjang = value.penunjang;
      this.dokter_id = value.dokter_id;
    } else {
      this.clearInput();

      if (!this.dokter_id && this.storeUser?.profesi == "Dokter") {
        this.dokter_id = this.storeUser.id;
        console.log("set nama dokter", this.storeUser.id);
      }
    }
  }

  passTtd(value) {
    this.$emit("passTtd", value);
  }

  get input() {
    let tujuanNama = null,
      tujuanId = null;

    if (this.tujuan) {
      tujuanNama = this.tujuan.nama;
      tujuanId = this.tujuan.id;
    } else if (this.tujuanLainnya) {
      tujuanId = this.tujuanLainnya?.id ?? "#";
      tujuanNama = this.tujuanLainnya?.nama ?? this.tujuanLainnya;
    }

    return {
      type: "ranap",
      pasien_rm: this.rm,
      register_id: this.register,
      tujuan_id: tujuanId,
      tujuan_nama: tujuanNama,
      unit_tujuan_text: this.unit_tujuan_text,
      dokter_id: this.dokter_id,
      unit_id: userModule.user.unit_id,
      diagnosis: this.diagnosis,
      alasan: this.alasan,
      kondisi: this.kondisi,
      terapi_diberikan: this.terapi_diberikan,
      penunjang: this.penunjang
    };
  }

  async save() {
    if (this.readOnly) return;
    if (!this.saving) {
      this.saving = true;

      try {
        const resp = storeSuratRujukanRanap.rujukan
          ? SuratRujukanRanap.update(
              storeSuratRujukanRanap.rujukan.id,
              this.input
            )
          : SuratRujukanRanap.create(this.input);

        await resp.then(resp => {
          if (resp.data.status) {
            storeSuratRujukanRanap.getByRegister(this.register);

            this.dialog = false;

            if (
              !storeSuratRujukanRanap.rujukan?.signed_at &&
              this.isUserSignee
            ) {
              this.modalTtd = true;
            }
          }
        });
      } finally {
        this.saving = false;
      }
    }
  }

  showInputFaskesLainnya = false;
  tujuanLainnya = null;
  readonlyTujuan = false;
  focusTujuanLainnyaField = false;
  loadingListFaskesLainnya = false;
  searchFaskesLainnya = "";
  _timerId;

  @Watch("showInputFaskesLainnya")
  changeShowInputFaskesLainnya(val) {
    if (val === false) {
      this.tujuanLainnya = "";
      this.readonlyTujuan = false;
    } else {
      this.focusTujuanLainnyaField = true;
      this.tujuan = null;
      this.readonlyTujuan = true;
    }
  }

  @Watch("searchFaskesLainnya", { deep: true })
  searchedFaskes() {
    this.listFaskesLainnya = [];

    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (
        this.searchFaskesLainnya === null ||
        this.searchFaskesLainnya.length < 2 ||
        this.tujuanLainnya === this.searchFaskesLainnya
      )
        return;
      this.loadingListFaskesLainnya = true;

      const dt = DataRujukan.getDataFaskesCustom(this.searchFaskesLainnya);
      dt.then(dt => {
        this.listFaskesLainnya = dt.map(faskesLainnya => {
          return faskesLainnya;
        });
        if (!dt.length) {
          this.tujuanLainnya = this.searchFaskesLainnya;
        }
      }).finally(() => (this.loadingListFaskesLainnya = false));
    }, 500);
  }

  clearInput() {
    // this.rm = null;
    // this.register = null;
    this.unit_tujuan_text = null;
    this.diagnosis = null;
    this.alasan = null;
    this.kondisi = null;
    this.terapi_diberikan = null;
    this.penunjang = null;
    this.tujuan = null;
    this.dokter_id = null;

    this.showInputFaskesLainnya = false;
    this.tujuanLainnya = null;
    this.readonlyTujuan = false;
    this.focusTujuanLainnyaField = false;
    this.loadingListFaskesLainnya = false;
    this.searchFaskesLainnya = "";
  }

  close() {
    this.dialog = false;
  }
}
